import api from '../../../api';
import decode from 'jwt-decode';
import setAuthorizationHeader from '../../../utils/setAuthorizationHeader';
import retrieveUserDataRepeated from '../../../utils/retrieveUserDataRepeated';
import retrieveUserDataRepeatedSocial from '../../../utils/retrieveUserDataRepeatedSocial';
import formatUserData from '../../../utils/formatUserData.js';
import store from "../../index";
import triggerPinpointCognitoAnalytics from "../../../helpers/pinpoints/triggerCognitoPinpointAnalytics";
import sendPinpointWelcomeEmail from "../../../helpers/pinpoints/sendPinpointWelcomeEmail";

export default {
	RETRIEVE_USER({commit}) {
		console.info("RETRIEVE_USER");
		console.time("RETRIEVE_USER");
		return api.cognito.retrieveCurrentUser().then(user => {
			setAuthorizationHeader(user.idToken);
			if (user.identities.length) {
				// The user is logged in with social networks
				return api.cognito.retrieveUserAttributes().then(attributesObject => {
					let onboardingcomplete = attributesObject.onboardingcomplete || "Skipped";
					commit('USER_LOGGED_IN', {
						user: {
							...user,
							onboardingcomplete: onboardingcomplete
						},
						source: 'cognito'
					});
				});
			} else {
				commit('USER_LOGGED_IN', {
					user,
					source: 'cognito'
				});
			}
		});
	},
	REFRESH_SESSION({commit, state}, {onboardingcomplete}) {
		console.info("REFRESH_SESSION");
		console.time("REFRESH_SESSION");
		const refreshToken = state.user.refreshToken;

		if (!refreshToken) {
			// The user is logged in via Social networks and doesn't have Refresh token (user data will be received from the server instead of localstorage)
			commit('UPDATE_USER_DATA', {
				userData: {
					onboardingcomplete
				}
			});

			return Promise.resolve();
		}

		return api.cognito.refreshSession({refreshToken}).then(tokens => {
			const decodedIdToken = decode(tokens.idToken);

			setAuthorizationHeader(tokens.idToken);
			commit('UPDATE_USER_DATA', {
				userData: {
					...tokens,
					onboardingcomplete: decodedIdToken['custom:onboarding_status']
				}
			});
		});
	},
	RETRIEVE_USER_DATA({commit, dispatch}) {
		console.info("RETRIEVE_USER_DATA");
		console.time("RETRIEVE_USER_DATA");
		return api.crm.retrieveUserRecord().then(userData => {
			if (!userData) {
				dispatch('RETRIEVE_USER').then(() => {
					let userData = formatUserData(store.state.user.user);
					commit('UPDATE_USER_DATA', {
						userData: userData.user,
						source: 'cognito'
					});
					dispatch('onboarding/UPDATE_ONBOARDING_STATE', userData, {root: true});
				});
			} else {
				commit('UPDATE_USER_DATA', {
					userData: userData.user,
					source: 'cognito'
				});
				dispatch('onboarding/UPDATE_ONBOARDING_STATE', userData, {root: true});
			}
		});
	},
	RETRIEVE_USER_DATA_SOCIAL({commit, dispatch}) {
		console.info("RETRIEVE_USER_DATA_SOCIAL");
		console.time("RETRIEVE_USER_DATA_SOCIAL");
		return api.crm.retrieveUserRecordSocial().then(userData => {
			commit('UPDATE_USER_DATA', {
				userData: userData.user,
				source: 'cognito'
			});
			dispatch('onboarding/UPDATE_ONBOARDING_STATE', userData, {root: true});
		});
	},
	LOGIN({commit, dispatch}, credentials) {
		console.info("LOGIN");
		console.time("LOGIN");

		return api.cognito.login(credentials).then(async user => {
			console.log('user.isFirstLogin', user.isFirstLogin)
			if (user.isFirstLogin === "true") {
				// TODO: need to enable again
				// await triggerPinpointCognitoAnalytics(credentials.email, credentials.password)
				// TODO: Skipped - Use aws secret manager or iam role for this, we are not using Access keys anymore
				// await sendPinpointWelcomeEmail(user.family_name, user.email, user.username)
				user.isFirstLogin = false
				await api.cognito.updateUserDetails(user);
			}
			console.log(user.idToken)
			setAuthorizationHeader(user.idToken);
			commit('USER_LOGGED_IN', {
				user,
				source: 'cognito'
			});

			if (user.username && user.ffa_preferenceonboardingform !== 'New') {
				return dispatch('RETRIEVE_USER_DATA');
			} else {
				return retrieveUserDataRepeated(dispatch);
			}
		});
	},
	REGISTER(_, userData) {
		console.info("REGISTER");
		console.time("REGISTER");

		return api.cognito.register(userData);
	},
	VERIFY(_, data) {
		console.info("VERIFY");
		console.time("VERIFY");

		return api.cognito.verify(data);
	},
	LOGOUT({commit, dispatch}) {
		console.info("LOGOUT");
		console.time("LOGOUT");

		return api.cognito.logout().then(() => {
			dispatch('onboarding/CLEAR_ONBOARDING_STATE', {}, {root: true});
			commit('USER_LOGGED_OUT');
		});
	},
	UPDATE_USER_DETAILS({commit, state}, userData) {
		console.info("UPDATE_USER_DETAILS");
		console.time("UPDATE_USER_DETAILS");

		return api.crm.updateUserDetails(userData).then(updatedData => {
			// Update user details in cognito instance
			return api.cognito.updateUserDetails(updatedData.user).then(() => {
				const user = {
					...state.user,
					...updatedData.user
				};

				commit('USER_LOGGED_IN', {user});
			});
		});
	},
	CHANGE_PASSWORD(_, userPasswords) {
		console.info("CHANGE_PASSWORD");
		console.time("CHANGE_PASSWORD");

		return api.cognito.changePassword(userPasswords);
	},
	RESEND_CODE(_, data) {
		console.info("RESEND_CODE");
		console.time("RESEND_CODE");

		return api.cognito.resendCode(data);
	},
	CHANGE_EMAIL(_, emailData) {
		console.info("CHANGE_EMAIL");
		console.time("CHANGE_EMAIL");

		return api.cognito.changeEmail(emailData);
	},
	VERIFY_CHANGED_EMAIL({commit, state}, emailData) {
		console.info("VERIFY_CHANGED_EMAIL");
		console.time("VERIFY_CHANGED_EMAIL");

		return api.cognito.verifyChangedEmail(emailData)
			.then(async () => {
				commit('UPDATE_USER_DATA', {
					userData: {
						email: emailData.email
					}
				});
				await api.crm.updateUserDetails({
					firstname: state.user.given_name,
					lastname: state.user.family_name,
					birthdate: state.user.birthdate,
					emailaddress1: emailData.email
				})
			});
	},
	RESET_PASSWORD(_, emailData) {
		console.info("RESET_PASSWORD");
		console.time("RESET_PASSWORD");

		return api.cognito.resetPassword(emailData);
	},
	CREATE_NEW_PASSWORD(_, userData) {
		console.info("CREATE_NEW_PASSWORD");
		console.time("CREATE_NEW_PASSWORD");

		return api.cognito.createPassword(userData);
	},
	LOGIN_SOCIAL_PROVIDER({dispatch, state}, userData) {
		console.info("LOGIN_SOCIAL_PROVIDER");
		console.time("LOGIN_SOCIAL_PROVIDER");

		//return new Promise((res) => {
		return api.cognito.createUserSession(userData);
		//    setTimeout(res, 2000, state);
		//});
	},
	RETRIEVE_USER_REPEATED_SOCIAL({dispatch}) {
		console.info("RETRIEVE_USER_REPEATED_SOCIAL");
		console.time("RETRIEVE_USER_REPEATED_SOCIAL");

		return retrieveUserDataRepeatedSocial(dispatch);
	},
	BANGEO_SAVE_USER() {
		console.info("BANGEO_SAVE_USER");
		console.time("BANGEO_SAVE_USER");

		return api.bangeo.saveUser(true);
	}
};
